import { createSlice } from "@reduxjs/toolkit";

const inputSlice = createSlice({
  name: "input",
  initialState: {
    activeStep: 0,
    leadData: {},
    frontendBootData: {},
    filters: {
      sum_insured: "50000",
      insurers: [],
      sortBy: "Low To High",
      planType: "Single Trip",
    },
    traceId: "",
    uuid: "",
    verificationStatus: false,
     blockTata:false,
     disableMembers:false
  },
  reducers: {
    setActiveStep: (state, action) => {
      state.activeStep = action.payload;
    },
    setVerificationStatus: (state, action) => {
      state.verificationStatus = action.payload;
    },
    setUuid: (state, action) => {
      state.uuid = action.payload;
    },
    setLeadData: (state, action) => {
      state.leadData = { ...state.leadData, ...action.payload };
    },
    setFrontendBoot: (state, action) => {
      state.frontendBootData = { ...state.frontendBootData, ...action.payload };
    },
    setSumInsurer: (state, action) => {
      state.filters.sum_insured = action.payload;
    },
    setSortBy: (state, action) => {
      state.filters.sortBy = action.payload;
    },
    setInsurers: (state, action) => {
      state.filters.insurers = action.payload;
    },
    setPlanType: (state, action) => {
      state.filters.planType = action.payload;
    },
    setTraceId: (state, action) => {
      state.traceId = action.payload;
    },

    setBlockTata:(state,action)=>{
      state.blockTata=action.payload
    },

     setDisableMembers:(state,action)=>{
      state.disableMembers=action.payload
    },

    resetFilters: (state) => {
      state.filters = {
        planType: state.filters.planType,
        sum_insured: "50000",
        insurers: [],
        sortBy: "Low To High",
      };
    },
  },
});

export const {
  setPlanType,
  setActiveStep,
  setLeadData,
  setFrontendBoot,
  setSumInsurer,
  setSortBy,
  setTraceId,
  setInsurers,
  setUuid,
  resetFilters,
 setBlockTata,
 setDisableMembers
} = inputSlice.actions;

export default inputSlice.reducer;
